import React from 'react'

const OverlayDefault = (props) => {
  return null
}

export default OverlayDefault


// WEBPACK FOOTER //
// ./src/components/overlay/OverlayDefault.js